let currentStep = 1;
const progressFill = document.querySelector(".app__header-step");
const progressBar = document.querySelector(".section-quiz-app__progress--bar");
const progressText = document.querySelector(".progress-text");
const tabs = document.querySelectorAll(".block-quiz-tab");
const btnPrev = document.querySelector(".app__header-back");
const nextBtns = document.querySelectorAll(".section-app-quiz__next .button");
const radioBtns = document.querySelectorAll(
  '.section-app-quiz__tab input[type="radio"]'
);
const checkBoxes = document.querySelectorAll(
  '.section-app-quiz__tab input[type="checkbox"]'
);

function nextStep() {
  if (currentStep < tabs.length) {
    tabs[currentStep - 1].classList.remove("active-quiz__tab");
    currentStep++;
    tabs[currentStep - 1].classList.add("active-quiz__tab");
    updateProgress();
    updateActiveTab();
  }
}

nextBtns.forEach((nextBtn) => {
  nextBtn.addEventListener("click", () => {
    checkBoxes.forEach((checkbox) => {
      if (checkbox.checked) {
        if (currentStep < tabs.length) {
          tabs[currentStep - 1].classList.remove("active-quiz__tab");
          currentStep++;
          tabs[currentStep - 1].classList.add("active-quiz__tab");
          updateProgress();
          updateActiveTab();
        }
      }
    });
  });
});

radioBtns.forEach((radioBtn) => {
  radioBtn.addEventListener("click", () => {
    if (radioBtn.checked) {
      if (currentStep < tabs.length) {
        tabs[currentStep - 1].classList.remove("active-quiz__tab");
        currentStep++;
        tabs[currentStep - 1].classList.add("active-quiz__tab");
        updateProgress();
        updateActiveTab();
      }
    }
  });
});

btnPrev.addEventListener("click", () => {
  if (currentStep > 1) {
    tabs[currentStep - 1].classList.remove("active-quiz__tab");
    currentStep--;
    tabs[currentStep - 1].classList.add("active-quiz__tab");
    updateProgress();
    updateActiveTab();
  }
});

function updateProgress() {
  const percent = ((currentStep - 1) / (tabs.length - 1)) * 100;
  progressBar.style.width = `${percent}%`;
  //progressFill.style.width = `${percent}%`;
  //progressText.textContent = `${Math.round(percent)}%`;
  //progressText.style.left = `calc(${percent}% - ${
  //  progressText.clientWidth / 2
  // }px)`;
}
function updateActiveTab() {
  const activeTabInfo = document.getElementById("app-current-step");
  activeTabInfo.innerHTML = `${currentStep}`;
}
